import React, { useState, useEffect } from 'react'
import './employee.css'
import { Link } from 'react-router-dom'
import { FaUsers,FaUser,FaUserAlt } from "react-icons/fa";
import { HiUsers } from "react-icons/hi";
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import { useForm } from 'react-hook-form';
import profile from '../../../assets/profile.png'
import { useSelector, useDispatch} from 'react-redux'
import {getAllUsers, addEmployee} from '../../../api'
import {handleStaffs} from '../../../state/userSlice'
import {handleOpenModal, handleCloseModal} from '../../../state/modalSlice'
import moment from 'moment';
import Loader from '../../../components/loader/Loader'
import ActionCell from '../../../components/actionCell/ActionCell'
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content';

// Create a SweetAlert2 instance with React integration
const MySwal = withReactContent(Swal);


const columns = [
    {
        field: 'name',
        headerName: 'Name',
        width: 250,
        renderCell: (param)=>{
            return (
                <div className='employees__table-profile'>
                    <img src={!param.row.profilePic ? profile
                    : `https://hrms.aspomportal.com/upload/${param.row.profilePic}`} 
                    alt={param.row.firstName + ' ' + param.row.lastName}
                    className="employees__table-img" />
                    <div className="employees__table-profile_list">
                        <h4 className="employees__table-profile_name">
                            {param.row.firstName + ' ' + param.row.lastName}
                        </h4>
                        <span className="employees__table-profile_email">
                            {param.row.email}
                        </span>
                    </div>
                </div>
            )
        }
    },
    {
        field: 'staffId',
        headerName: 'Employee ID',
        width: 150,
        editable: true,
    },
    {
        field: 'department',
        headerName: 'Department',
        width: 150,
    },
    {
        field: 'role',
        headerName: 'Role',
        width: 150,
    },
    {
        field: 'createdAt',
        headerName: 'Join Date',
        width: 120,
        renderCell: (param) => (
            <span>
                {moment(param.row.createdAt).format('DD MMMM YYYY')}
            </span>
        )
    },
    {
        field: 'action',
        headerName: 'Action',
        width: 100,
        renderCell: (param) => <ActionCell param={param} text="View" to={`/profile/${param.row._id}`}/>
    },
];


const AddEmployee = ({user, closeModal, handleFetchUsers}) => {
    const [isLoading, setIsLoading] = useState(false)
    const {
        register,
        handleSubmit,
        formState:{errors},
        reset,
        getValues
    } = useForm({
        mode: 'onChange',
    })

    const handleOnSubmit = async (data) => {
        setIsLoading(true)
        try{
            const res = await addEmployee(user?.token, data)
            if(res?.success){
                MySwal.fire({
                    icon: 'success',
                    title: res?.message,
                    showConfirmButton: false,
                    timer: 2000
                });
                reset()
                handleFetchUsers()
            }else{
                MySwal.fire({
                    icon: 'error',
                    title: res?.message,
                    showConfirmButton: false,
                    timer: 2000
                });
            }
            setIsLoading(false)
        }catch(error){
            console.log(error)
            setIsLoading(false)
            MySwal.fire({
                icon: 'error',
                title: "There's an error processing your request, Try again",
                showConfirmButton: false,
                timer: 2000
            });
        }
    }

    return (
        <div className="modal" onClick={closeModal}>
            <div className="modal-container">
                <div className="modal-content overflow" 
                onClick={(e)=>e.stopPropagation()}>
                    <div className="modal-heading">
                        <h4 className="modal-title">Add Employee</h4>
                        <button type='button' onClick={closeModal}
                        className="modal-btn">
                            <i class='bx bx-x'></i>
                        </button>
                    </div>
                    <form className="modal-form" onSubmit={handleSubmit(handleOnSubmit)}>
                        <div className="modal-items">
                            <div className="modal-field">
                                <label htmlFor="firstName" className='modal-label'>
                                    First Name <span>*</span>
                                </label>
                                <input type="text" name='firstName' 
                                {...register('firstName',{
                                    required: 'This field is required!'
                                })}
                                className="modal-input" />
                                {
                                    errors?.firstName && <span>{errors?.firstName?.message}</span>
                                }
                            </div>
                            <div className="modal-field">
                                <label htmlFor="lastName" className='modal-label'>
                                    Last Name <span>*</span>
                                </label>
                                <input type="text" name='lastName'
                                {...register('lastName',{
                                    required: 'This field is required!'
                                })}
                                className="modal-input" />
                                {
                                    errors?.lastName && <span>{errors?.lastName?.message}</span>
                                }
                            </div>
                            <div className="modal-field">
                                <label htmlFor="employeeId" className='modal-label'>
                                    Employee ID <span>*</span>
                                </label>
                                <input type="text" name='employeeId' 
                                {...register('staffId',{
                                    required: 'This field is required!'
                                })}
                                className="modal-input" />
                                {
                                    errors?.staffId && <span>{errors?.staffId?.message}</span>
                                }
                            </div>
                            <div className="modal-field">
                                <label htmlFor="email" className='modal-label'>
                                    Email (example@aspomtravels.com)<span>*</span>
                                </label>
                                <input type="email" name='email' 
                                {...register('email',{
                                    required: 'This field is required!'
                                })}
                                className="modal-input" />
                                {
                                    errors?.email && <span>{errors?.email?.message}</span>
                                }
                            </div>
                            <div className="modal-field">
                                <label htmlFor="password" className='modal-label'>
                                    Password
                                </label>
                                <input type="password" name='password' 
                                {...register('password')}
                                className="modal-input" />
                            </div>
                            <div className="modal-field">
                                <label htmlFor="cpassword" className='modal-label'>
                                    Confirm Password
                                </label>
                                <input type="password" name='cpassword' 
                                {...register('cpassword',{
                                    validate: (value)=>{
                                        const {password} = getValues()
                                        if(password !== value){
                                            return 'Password does not match'
                                        }
                                    }
                                })}
                                className="modal-input" />
                                {
                                    errors?.cpassword && <span>{errors?.cpassword?.message}</span>
                                }
                            </div>
                            <div className="modal-field">
                                <label htmlFor="phone" className='modal-label'>
                                    Phone
                                </label>
                                <input type="tel" name='phone' 
                                {...register('phone')}
                                className="modal-input" />
                            </div>
                            <div className="modal-field">
                                <label htmlFor="gender" className='modal-label'>
                                    Gender <span>*</span>
                                </label>
                                <select name="gender" 
                                {...register('gender',{
                                    required: 'This field is required!'
                                })}
                                className="modal-input">
                                    <option value="" disabled>Select a gender</option>
                                    <option value="Male">Male</option>
                                    <option value="Female">Female</option>
                                </select>
                                {
                                    errors?.firstName && <span>{errors?.firstName?.message}</span>
                                }
                            </div>
                            <div className="modal-field">
                                <label htmlFor="joinDate" className='modal-label'>
                                    Joining Date <span>*</span>
                                </label>
                                <input type="date" name='joinDate' 
                                {...register('joinDate',{
                                    required: 'This field is required!'
                                })}
                                className="modal-input" />
                                {
                                    errors?.joinDate && <span>{errors?.joinDate?.message}</span>
                                }
                            </div>
                            <div className="modal-field">
                                <label htmlFor="birthDay" className='modal-label'>
                                    Birth Date 
                                </label>
                                <input type="date" name='birthDay' 
                                {...register('birthDay')}
                                className="modal-input" />
                                {
                                    errors?.birthDay && <span>{errors?.birthDay?.message}</span>
                                }
                            </div>
                            <div className="modal-field">
                                <label htmlFor="department" className='modal-label'>
                                    Department <span>*</span>
                                </label>
                                <select name="department" 
                                {...register('department',{
                                    required: 'This field is required!'
                                })}
                                className="modal-input">
                                    <option value="" disabled>Select a department</option>
                                    <option value="Account">Account</option>
                                    <option value="Admin">Admin</option>
                                    <option value="Compliance">Compliance</option>
                                    <option value="HR">HR</option>
                                    <option value="IT Officer">IT Officer</option>
                                    <option value="Sales">Sales</option>
                                    <option value="Social Media">Social Media</option>
                                    <option value="Ticket">Ticket</option>
                                    <option value="Tour">Tour</option>
                                </select>
                                {
                                    errors?.department && <span>{errors?.department?.message}</span>
                                }
                            </div>
                            <div className="modal-field">
                                <label htmlFor="role" className='modal-label'>
                                    Role <span>*</span>
                                </label>
                                <select name="role" 
                                {...register('role',{
                                    required: 'This field is required!'
                                })}
                                className="modal-input">
                                    <option value="" disabled>Select a role</option>
                                    <option value="Officer">Officer</option>
                                    <option value="Manager">Manager</option>
                                    <option value="Supervisor">Supervisor</option>
                                </select>
                                {
                                    errors?.role && <span>{errors?.role?.message}</span>
                                }
                            </div>
                        </div>
                        <div className="modal-field bottom">
                            {
                                isLoading ? <Loader/> : <button type='submit'
                                className='modal-button button'>
                                    Add Employee
                                </button>
                            }
                            
                        </div>
                    </form>

                </div>
            </div>
        </div>
    )
}

const Employee = () => {
    const {user, staffs} = useSelector((state)=>state.user)
    const {modal} = useSelector((state)=>state.modal)
    const dispatch = useDispatch()
    const [value, setValue] = useState('')

    const openModal = () => {
        dispatch(handleOpenModal())
    }

    const closeModal = () => {
        dispatch(handleCloseModal())
    }

    const handleFetchUsers = async () => {
        try{
            const res = await getAllUsers(user?.token)
            dispatch(handleStaffs(res?.data))
        }catch(error){
            console.log(error)
        }
    }

    const filterItems = staffs?.filter((item)=>{
        return item?.firstName.toLowerCase().includes(value.toLowerCase())
        || item?.lastName.toLowerCase().includes(value.toLowerCase())
        || item?.email.toLowerCase().includes(value.toLowerCase())
    })

    const today = new Date()
    const twoMonthsAgo = new Date(today.getFullYear(), today.getMonth() - 2, today.getDate());

    const staffsTwoMonthsAgo = staffs?.filter((item) => {
        const createdAtDate = new Date(item?.createdAt);
        return createdAtDate >= twoMonthsAgo && createdAtDate < today;
    });

    const staffsTwoMonthsAgoLength = staffsTwoMonthsAgo?.length;

    useEffect(()=>{
        handleFetchUsers()
    },[])

  return (
    <section className='employees'>
        {/* HEADING */}
        <div className="heading">
            <div className="heading__box">
                <div className="heading-item">
                    <h3 className="heading-title">All Employees | </h3>
                    <i class='bx bx-home heading__title-icon'></i>
                    <Link to="/" className="heading-text">
                        Home <i class='bx bx-chevron-right heading-icon'></i>
                    </Link>
                    <span className="heading-text">
                        Employees <i class='bx bx-chevron-right heading-icon'></i>
                    </span>
                </div>
                <p className="heading-text">
                    Employee list
                </p>
            </div>
            <button onClick={openModal}
            className="heading__box-btn button">
                Add employee
            </button>
        </div>

        <div className="employees__container">
            <div className="employees__cards">
                <div className="employees__card">
                    <div className="employees__card-item">
                        <h4 className="employees__card-title">
                            Total Employees
                        </h4>
                        <span className="employees__card-count">
                            {staffs?.length}
                        </span>
                    </div>
                    <div className="employees__card-icon">
                        <FaUsers size={50} color="green" />
                    </div>
                </div>
                <div className="employees__card">
                    <div className="employees__card-item">
                        <h4 className="employees__card-title">
                            New Employees
                        </h4>
                        <span className="employees__card-count">
                            {staffsTwoMonthsAgoLength}
                        </span>
                    </div>
                    <div className="employees__card-icon">
                        <HiUsers size={50} color="var(--violet-color)" />
                    </div>
                </div>
                <div className="employees__card">
                    <div className="employees__card-item">
                        <h4 className="employees__card-title">
                            Male
                        </h4>
                        <span className="employees__card-count">
                            {staffs?.filter((item)=>item?.gender?.toLowerCase() === 'male')?.length}
                        </span>
                    </div>
                    <div className="employees__card-icon">
                        <FaUser size={40} color="#1E90FF" />
                    </div>
                </div>
                <div className="employees__card">
                    <div className="employees__card-item">
                        <h4 className="employees__card-title">
                            Female
                        </h4>
                        <span className="employees__card-count">
                            {staffs?.filter((item)=>item?.gender?.toLowerCase() === 'female')?.length}
                        </span>
                    </div>
                    <div className="employees__card-icon">
                        <FaUserAlt size={40} color="var(--pink-color)" />
                    </div>
                </div>
            </div>
            <div className="employees__items">
                <div className="employees__search">
                    <h4 className="employees__search-title">Employee List</h4>
                    <div className="employees__search-box">
                        <span className="employees__search-span">Search:</span>
                        <input type="text" placeholder="Name or email..."
                        value={value} onChange={(e)=>setValue(e.target.value)}
                        className='employees__search-input'/>
                    </div>
                </div>

                <div className="employees__table">
                    <DataGrid
                        getRowId={(rows => rows._id)}
                        rows={filterItems ?? []}
                        columns={columns}
                        initialState={{
                        pagination: {
                            paginationModel: {
                            pageSize: 5,
                            },
                        },
                        }}
                        pageSizeOptions={[5]}
                        checkboxSelection
                        disableRowSelectionOnClick
                        getRowHeight={() => 'auto'} 
                        sx={{
                            '&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell': {
                                py: 0.5,
                            },
                            '&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell': {
                                py: '5px',
                            },
                            '&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell': {
                                py: '10px',
                            },
                        }}
                        experimentalFeatures={{ lazyLoading: true }}
                    />
                </div>
            </div>
        </div>
        {modal?.show && <AddEmployee 
        closeModal={closeModal}
        modal={modal}
        user={user}
        handleFetchUsers={handleFetchUsers}/>}
        
    </section>
  )
}

export default Employee